export const tables = {
  '00': 'Tabela própria',
  18: 'Tabela de diárias, taxas e gases',
  19: 'Tabela de materiais e OPMEs',
  20: 'Tabela de medicamentos',
  22: 'Procedimentos',
  98: 'Tabela de pacotes',
};

export function getName(value) {
  return tables[value];
}
